var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('h1', [_vm._v("Total time spent")]), _c('div', {
    staticClass: "inputsWrpr"
  }, [_c('div', {}, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.total_time_spent.days,
      expression: "total_time_spent.days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": _vm.total_time_spent.days
    },
    on: {
      "blur": _vm.$v.total_time_spent.days.$touch,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.total_time_spent, "days", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon21"
    }
  }, [_vm._v("Days")])])]), _c('div', {}, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.total_time_spent.hours,
      expression: "total_time_spent.hours"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "placeholder": "",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": _vm.total_time_spent.hours
    },
    on: {
      "blur": _vm.$v.total_time_spent.hours.$touch,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.total_time_spent, "hours", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon23"
    }
  }, [_vm._v("Hours")])])]), _c('div', {}, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.total_time_spent.minutes,
      expression: "total_time_spent.minutes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "placeholder": "",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": _vm.total_time_spent.minutes
    },
    on: {
      "blur": _vm.$v.total_time_spent.minutes.$touch,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.total_time_spent, "minutes", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon244"
    }
  }, [_vm._v("Mins")])])])]), _vm.getError('total_time_spent') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill total time spent ")]) : _vm._e(), !_vm.$v.total_time_spent.hours.integer ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill hours in integer")]) : _vm._e(), !_vm.$v.total_time_spent.hours.minValue || !_vm.$v.total_time_spent.hours.maxValue ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Hours should be between 0 and 23")]) : _vm._e(), !_vm.$v.total_time_spent.days.integer ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill days in integer")]) : _vm._e(), !_vm.$v.total_time_spent.days.minValue ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Days should be not be less than zero")]) : _vm._e(), !_vm.$v.total_time_spent.minutes.integer ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill minutes in integer")]) : _vm._e(), !_vm.$v.total_time_spent.minutes.minValue || !_vm.$v.total_time_spent.minutes.maxValue ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Minutes should be between 0 and 59 ")]) : _vm._e()]), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('h1', [_vm._v("Overall Distance")]), _c('div', {
    staticClass: "inputsWrpr"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.overall_distance.value,
      expression: "overall_distance.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0"
    },
    domProps: {
      "value": _vm.overall_distance.value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.overall_distance, "value", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.overall_distance.unit,
      expression: "overall_distance.unit"
    }],
    staticClass: "btn btn-outline-secondary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.overall_distance, "unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    staticClass: "dropdown-item",
    attrs: {
      "value": "kilometers"
    }
  }, [_vm._v(" km ")]), _c('option', {
    staticClass: "dropdown-item",
    attrs: {
      "value": "miles"
    }
  }, [_vm._v("mi")])])])])]), _vm.getError('overall_distance') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill over all distance ")]) : _vm._e()]), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('h1', [_vm._v("Overall Elevation")]), _c('div', {
    staticClass: "inputsWrpr"
  }, [_c('div', {}, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.overall_elevation_meter,
      expression: "overall_elevation_meter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "placeholder": "",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": _vm.overall_elevation_meter
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.overall_elevation_meter = $event.target.value;
      }
    }
  }), _c('span', {
    staticClass: "input-group-text",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Meter")])])])]), _vm.getError('overall_elevation_meter') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to fill over all elevation ")]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }